var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import dayjs from "../../../_virtual/dayjs.min.js";
import localizedFormat from "../../../_virtual/localizedFormat.js";
import relativeTime from "../../../_virtual/relativeTime.js";
import "../../../_virtual/zh-cn.js";
import "../../../_virtual/en.js";
import "../../../_virtual/fr.js";
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const PRESETS = {
  "en-US": {
    date: "MM/DD/YYYY",
    dateTime: "MM/DD/YYYY hh:mm:ss A"
  },
  "zh-CN": {
    date: "YYYY-MM-DD",
    dateTime: "YYYY-MM-DD HH:mm:ss"
  },
  "fr-FR": {
    date: "DD/MM/YYYY",
    dateTime: "DD/MM/YYYY HH:mm:ss"
  }
};
function getPreset(locale) {
  return PRESETS[locale] || PRESETS["en-US"];
}
__name(getPreset, "getPreset");
function getDayjsLocale(locale) {
  return locale.split("-")[0].toLowerCase() === "zh" ? "zh-cn" : "en";
}
__name(getDayjsLocale, "getDayjsLocale");
function formatDate(date, locale = "en-US", format) {
  return dayjs(date).locale(getDayjsLocale(locale)).format(format || getPreset(locale).date);
}
__name(formatDate, "formatDate");
function formatDateTime(date, locale = "en-US", format) {
  return dayjs(date).locale(getDayjsLocale(locale)).format(format || getPreset(locale).dateTime);
}
__name(formatDateTime, "formatDateTime");
export {
  formatDate,
  formatDateTime
};
//# sourceMappingURL=index.js.map
